import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreChannelState } from '../reducers';

export const selectStoreChannelState = createFeatureSelector<StoreChannelState>('storeChannel');

export const selectStoreChannelLoading = createSelector(
  selectStoreChannelState,
  (state: StoreChannelState) => state.loading
);

export const selectStoreChannelEditMode = createSelector(
  selectStoreChannelState,
  (state: StoreChannelState) => state.editMode
);

export const selectStoreChannel = createSelector(
  selectStoreChannelState,
  (state: StoreChannelState) => state.storeChannel
);

export const selectStoreChannelList = createSelector(
  selectStoreChannelState,
  (state: StoreChannelState) => state.storeChannelList
);

export const selectStoreChannelConfigurationList = createSelector(
  selectStoreChannelState,
  (state: StoreChannelState) => state.storeChannelConfigurationList
);

export const selectStoreChannelForm = createSelector(
  selectStoreChannelState,
  (state: StoreChannelState) => state.storeChannelForm
);

export const selectStoreChannelError = createSelector(
  selectStoreChannelState,
  (state: StoreChannelState) => state.error
);